import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Input } from '../components/Input';
import { Button } from '../components/Button';
export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    referrer: '',
    projectSummary: '',
    phone: '',
    budget: '',
    timeline: '',
    interests: [] as string[]
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [submitted, setSubmitted] = useState(false);
  const interestOptions = ['E-commerce solutions', 'Data import/export systems', 'MySQL database services', 'E-business applications', 'Global File System (GFS)', 'Custom web programming', 'Graphic design & UI/UX', 'Mobile app development (iOS/Android)', 'System integrations (API/EDI/XML)', 'AI & automation'];
  const validateForm = () => {
    const newErrors: Record<string, string> = {};
    if (!formData.name.trim()) newErrors.name = 'Please enter your name';
    if (!formData.email.trim()) newErrors.email = 'Please enter a valid email address';else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Please enter a valid email address';
    if (!formData.referrer.trim()) newErrors.referrer = 'Please let us know who referred you';
    if (!formData.projectSummary.trim()) newErrors.projectSummary = 'Please provide a brief project description';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      setSubmitted(true);
      // In production, send to backend
      console.log('Form submitted:', formData);
    }
  };
  const handleInterestToggle = (interest: string) => {
    setFormData(prev => ({
      ...prev,
      interests: prev.interests.includes(interest) ? prev.interests.filter(i => i !== interest) : [...prev.interests, interest]
    }));
  };
  if (submitted) {
    return <div className="min-h-screen w-full bg-white flex items-center justify-center" data-id="element-157">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="max-w-2xl mx-auto px-4 text-center" data-id="element-158">
          <div className="bg-surface rounded-2xl p-12" data-id="element-159">
            <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-160">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-161">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-162" />
              </svg>
            </div>
            <h2 className="text-3xl font-bold text-ink mb-4" data-id="element-163">
              Thank You for Reaching Out
            </h2>
            <p className="text-lg text-gray-600" data-id="element-164">
              We've received your inquiry and will review it shortly. A member
              of our team will be in touch within 1-2 business days to discuss
              your project.
            </p>
          </div>
        </motion.div>
      </div>;
  }
  return <div className="min-h-screen w-full bg-white" data-id="element-165">
      <section className="py-20" data-id="element-166">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center mb-12" data-id="element-168">
            <h1 className="text-4xl md:text-5xl font-bold text-ink mb-6" data-id="element-169">
              Let's Discuss Your Project
            </h1>
            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl mx-auto" data-id="element-170">
              We accept new clients by referral to ensure the best fit and
              maintain our commitment to quality. If a trusted partner or
              colleague recommended Magnus Software, we're ready to discuss your
              project.
            </p>
          </motion.div>

          <motion.form initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} onSubmit={handleSubmit} className="bg-surface rounded-2xl p-8 md:p-12" data-id="element-171">
            <div className="space-y-6" data-id="element-172">
              <Input label="Full Name" type="text" placeholder="John Smith" value={formData.name} onChange={value => setFormData({
              ...formData,
              name: value
            })} error={errors.name} required data-id="element-173" />

              <Input label="Email Address" type="email" placeholder="john@company.com" value={formData.email} onChange={value => setFormData({
              ...formData,
              email: value
            })} error={errors.email} required data-id="element-174" />

              <Input label="Company Name" type="text" placeholder="Acme Corporation" value={formData.company} onChange={value => setFormData({
              ...formData,
              company: value
            })} data-id="element-175" />

              <Input label="Who referred you to Magnus Software?" type="text" placeholder="Name or company that recommended us" value={formData.referrer} onChange={value => setFormData({
              ...formData,
              referrer: value
            })} error={errors.referrer} helperText="We accept new projects by referral to ensure the best fit. If you're not sure who to list, a mutual connection or professional contact works too." required data-id="element-176" />

              <Input label="Tell us about your project" type="textarea" placeholder="Describe what you're looking to build, the problem you're solving, or the goals you want to achieve..." value={formData.projectSummary} onChange={value => setFormData({
              ...formData,
              projectSummary: value
            })} error={errors.projectSummary} helperText="A few sentences about your needs helps us prepare for our conversation." rows={5} required data-id="element-177" />

              <Input label="Phone Number" type="tel" placeholder="(555) 123-4567" value={formData.phone} onChange={value => setFormData({
              ...formData,
              phone: value
            })} data-id="element-178" />

              <div className="flex flex-col gap-1.5" data-id="element-179">
                <label className="text-sm font-semibold text-ink" data-id="element-180">
                  Estimated Budget
                </label>
                <select value={formData.budget} onChange={e => setFormData({
                ...formData,
                budget: e.target.value
              })} className="w-full px-4 py-3 border border-neutral rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-white" data-id="element-181">
                  <option value="" data-id="element-182">Select a range</option>
                  <option value="prefer-not-to-say" data-id="element-183">Prefer not to say</option>
                  <option value="under-25k" data-id="element-184">Under $25,000</option>
                  <option value="25k-50k" data-id="element-185">$25,000 - $50,000</option>
                  <option value="50k-100k" data-id="element-186">$50,000 - $100,000</option>
                  <option value="100k-250k" data-id="element-187">$100,000 - $250,000</option>
                  <option value="250k-plus" data-id="element-188">$250,000+</option>
                </select>
              </div>

              <div className="flex flex-col gap-1.5" data-id="element-189">
                <label className="text-sm font-semibold text-ink" data-id="element-190">
                  Desired Timeline
                </label>
                <select value={formData.timeline} onChange={e => setFormData({
                ...formData,
                timeline: e.target.value
              })} className="w-full px-4 py-3 border border-neutral rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-white" data-id="element-191">
                  <option value="" data-id="element-192">Select a timeline</option>
                  <option value="flexible" data-id="element-193">Flexible</option>
                  <option value="1-3-months" data-id="element-194">1-3 months</option>
                  <option value="3-6-months" data-id="element-195">3-6 months</option>
                  <option value="6-12-months" data-id="element-196">6-12 months</option>
                  <option value="12-plus-months" data-id="element-197">12+ months</option>
                </select>
              </div>

              <div className="flex flex-col gap-3" data-id="element-198">
                <label className="text-sm font-semibold text-ink" data-id="element-199">
                  What services are you interested in? (select all that apply)
                </label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-200">
                  {interestOptions.map(interest => <label key={interest} className="flex items-center gap-3 p-3 bg-white rounded-lg border border-neutral cursor-pointer hover:border-primary transition-colors" data-id="element-201">
                      <input type="checkbox" checked={formData.interests.includes(interest)} onChange={() => handleInterestToggle(interest)} className="w-4 h-4 text-primary border-neutral rounded focus:ring-2 focus:ring-primary" data-id="element-202" />
                      <span className="text-sm text-gray-700" data-id="element-203">{interest}</span>
                    </label>)}
                </div>
              </div>

              <div className="pt-4" data-id="element-204">
                <p className="text-sm text-gray-600 mb-6" data-id="element-205">
                  Don't have a referral? We occasionally consider projects that
                  align exceptionally well with our expertise. Feel free to
                  share your connection to Magnus Software or how you found us.
                </p>

                <Button type="submit" variant="primary" size="lg" className="w-full" data-id="element-206">
                  Submit Inquiry
                </Button>
              </div>
            </div>
          </motion.form>
        </div>
      </section>
    </div>;
}